import type { BrowserHistory } from 'history';
import { createBrowserHistory } from 'history';

export const history: BrowserHistory = createBrowserHistory();
